const genArgConverter =
  converter =>
    acceptor =>
      (...args) => {
        const conversion = converter(...args)

        if (conversion instanceof Array) {
          return acceptor(...conversion)
        }

        return acceptor(conversion)
      }

export default genArgConverter



// WEBPACK FOOTER //
// ./src/utils/gen-arg-converter.ts